import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { MarkAbsentComponent } from "../new-v2-component/mark-absent/mark-absent.component";
import { MatDialog } from "@angular/material/dialog";
import { CreateInvoiceForFitnessComponent } from "src/app/shared/components/create-invoice-for-fitness/create-invoice-for-fitness.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { MemberViewDetailsComponent } from "src/app/shared/components/member-view-details/member-view-details.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { EnrolledMemberPhoneChangeComponent } from "../new-v2-component/enrolled-member-phone-change/enrolled-member-phone-change.component";
import { FollowerChatComponent } from "src/app/shared/components/follower-chat/follower-chat.component";
import { PaymentIntimationComponent } from "src/app/shared/components/payment-intimation/payment-intimation.component";
import { AuthService } from "src/app/providers/auth.service";
import { AlertForEmailComponent } from "src/app/shared/components/alert-for-email/alert-for-email.component";
import { MemberEditPersonalDataComponent } from "src/app/shared/components/member-edit-personal-data/member-edit-personal-data.component";
import { MemberEditOptedServicePackagesComponent } from "src/app/shared/components/member-edit-opted-service-packages/member-edit-opted-service-packages.component";
import { MemberEditOptedTimingsComponent } from "src/app/shared/components/member-edit-opted-timings/member-edit-opted-timings.component";
import { EditMemberMeetingInfoComponent } from "../new-v2-component/edit-member-meeting-info/edit-member-meeting-info.component";
import { EditMemberAddressComponent } from "../new-v2-component/edit-member-address/edit-member-address.component";

@Component({
  selector: "sm-member-details",
  templateUrl: "./member-details.component.html",
  styleUrls: ["./member-details.component.scss"],
})
export class MemberDetailsComponent implements OnInit, OnDestroy {
  apisub: Subscription;
  isEntityIndividual: any = sessionStorage.getItem("isEntityIndividual");
  loader: boolean = false;
  memberDetailsData: any = [];
  trackersData: any = [];
  discountInfo: any = null;
  latestDate: any = null;
  entityHashId: string = "";
  isOwner: boolean = false;
  constructor(
    private navservice: NavigationService,
    private _apiservice: ApiService,
    private loaderservice: LoaderServiceService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLLED_MEMBER_DETAILS
      ) {
        if (this.toChange == true) {
          this.memberDetailsData = [];
          if (resdata.result) {
            this.memberDetailsData = resdata.result[0];
            if (
              this.memberDetailsData.services &&
              typeof this.memberDetailsData.services == "string"
            ) {
              this.memberDetailsData.services = JSON.parse(
                this.memberDetailsData.services,
              );
            }
            if (
              this.memberDetailsData.total_wallet &&
              typeof this.memberDetailsData.total_wallet == "string"
            ) {
              this.memberDetailsData.total_wallet = JSON.parse(
                this.memberDetailsData.total_wallet,
              );
            }
            if (
              this.memberDetailsData.timings &&
              typeof this.memberDetailsData.timings == "string"
            ) {
              this.memberDetailsData.timings = JSON.parse(
                this.memberDetailsData.timings,
              );
            }
            if (
              this.memberDetailsData.custom_items &&
              typeof this.memberDetailsData.custom_items == "string"
            ) {
              this.memberDetailsData.custom_items = JSON.parse(
                this.memberDetailsData.custom_items,
              );
            }
            if (
              this.memberDetailsData.assign_to &&
              typeof this.memberDetailsData.assign_to == "string"
            ) {
              this.memberDetailsData.assign_to = JSON.parse(
                this.memberDetailsData.assign_to,
              );
            }
            if (
              this.memberDetailsData.member_address &&
              typeof this.memberDetailsData.member_address == "string"
            ) {
              this.memberDetailsData.member_address = JSON.parse(
                this.memberDetailsData.member_address,
              );
            }

            if (this.memberDetailsData.coupon_info) {
              this.memberDetailsData.coupon_info =
                typeof this.memberDetailsData.coupon_info == "string"
                  ? JSON.parse(this.memberDetailsData.coupon_info)
                  : this.memberDetailsData.coupon_info;
            }
            if (
              this.memberDetailsData.products &&
              typeof this.memberDetailsData.products == "string"
            ) {
              this.memberDetailsData.products = JSON.parse(
                this.memberDetailsData.products,
              );
              this.memberDetailsData.products =
                this.memberDetailsData.products.map((item: any) => {
                  return {
                    rate: item.product_price,
                    status: item.status,
                    hash_id: item.hash_id,
                    img_url: item.product_img_url,
                    currency: item.currency,
                    description: item.product_description,
                    product_qty: item.item_qty,
                    product_name: item.product_name,
                    creation_time: item.creation_time,
                    tax_slab_hash: item.tax_slab_hash,
                    currency_symbol: item.currency_symbol,
                    entity_product_hash: item.entity_product_hash,
                  };
                });
            }
            if (this.memberDetailsData.service_mode == 0) {
              this.memberDetailsData.s_mode = "Home service";
            } else if (this.memberDetailsData.service_mode == 1) {
              this.memberDetailsData.s_mode = "In-premise service";
            } else if (this.memberDetailsData.service_mode == 2) {
              this.memberDetailsData.s_mode = "Virtual service";
            }

            if (this.memberDetailsData.coupon_code) {
              if (
                this.memberDetailsData?.coupon_use_limit != 0 &&
                this.memberDetailsData?.coupon_use_limit ==
                  this.memberDetailsData?.coupon_use_counter
              ) {
                this.memberDetailsData.net_payable =
                  this.memberDetailsData.membership_fee -
                  this.memberDetailsData.discount;
              }
            }

            // this.memberDetailsData.opted_services = this.memberDetailsData.services ?  this.getServiceNames(this.memberDetailsData.services) : null
            // this.memberDetailsData.opted_cis = this.memberDetailsData.custom_items ? this.getCustomItemNames(this.memberDetailsData.custom_items) : null
            // this.memberDetailsData.opted_products = this.memberDetailsData.products ? this.getProductsNames(this.memberDetailsData.products) : null
            if (
              this.memberDetailsData.timings &&
              this.memberDetailsData.timings != "null"
            ) {
              this.memberDetailsData.opted_timings = this.formatSchedule(
                this.memberDetailsData.timings,
              );
            }
            // this.memberData.discount = this.memberDetailsData.discount

            // this.selectedServiceType = this.memberDetailsData.service_mode
            console.log(this.memberDetailsData);

            sessionStorage.setItem("mefrp", this.memberDetailsData.email);
          }
          this._apiservice.getBillDiscountData(
            localStorage.getItem(
              SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
            ),
          );
          this.toChange = false;
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }

        this._apiservice.getProgressTrackersForMember(this.memberHash);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_PROGRESS_TRACKERS_FOR_MEMBER
      ) {
        this.trackersData = [];

        if (resdata.result) {
          this.trackersData = resdata.result;

          this.trackersData.forEach((element: any) => {
            element.tracking_logs =
              typeof element.tracking_logs == "string"
                ? JSON.parse(element.tracking_logs)
                : element.tracking_logs;

            if (element.tracking_logs) {
              // create a sorted copy of logs (oldest first)
              const sortedLogs = [...element.tracking_logs].sort(
                (a: any, b: any) =>
                  new Date(a.creation_time).getTime() -
                  new Date(b.creation_time).getTime(),
              );

              const reversersortedLogs = [...element.tracking_logs].sort(
                (a: any, b: any) =>
                  new Date(b.creation_time).getTime() -
                  new Date(a.creation_time).getTime(),
              );
              element.sortedLogs = reversersortedLogs;
            }
          });

          // ✅ Find latest creation_time after parsing
          let latestDate: string | null = null;

          this.trackersData.forEach((element: any) => {
            if (Array.isArray(element.tracking_logs)) {
              element.tracking_logs.forEach((log: any) => {
                const creationTime = log?.creation_time;
                if (creationTime) {
                  if (!latestDate || creationTime > latestDate) {
                    latestDate = creationTime;
                  }
                }
              });
            }
          });

          this.latestDate = latestDate;
          console.log("Latest Creation Time (raw):", this.latestDate);
        }

        this.loader = false;
        this.loaderservice.showLoader = false;
      }

      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_ENROLLED_MEMBER_MEMBERSHIP_STATUS
      ) {
        if (resdata.result) {
          this.toChange = true;
          this._apiservice.getEnrolledMemberDetails(this.memberHash);
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE
      ) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_MEMBER_DATA
      ) {
        if (resdata.result) {
          // this._apiservice.getEnrolledMemberDetails(this.memberHash)
          this.router.navigate(["../"], {
            relativeTo: this.route,
            queryParams: { entityHash: this.entityHash, eph: this.eph },
          });
        }
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resdata.result) {
          this.loaderservice.showLoader = false;
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_ENTITY_INVOICE
      ) {
        if (resdata.result) {
          this.toChange = true;
          this._apiservice.getEnrolledMemberDetails(this.memberHash);
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE
      ) {
        if (resdata.result) {
          this.toChange = true;
          this._apiservice.getEnrolledMemberDetails(this.memberHash);
        }
      }
      if (resdata.responseType === SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID) {
        if (this.isFromThis) {
          this.isFromThis = false;
          this.previousChatHash = null;
          // this.chatThreads = []
          if (resdata.result) {
            resdata.result.forEach((element: any) => {
              if (element.senderInfo && element.receiverInfo) {
                if (
                  element.senderInfo &&
                  typeof element.senderInfo == "string"
                ) {
                  element.senderInfo = JSON.parse(element.senderInfo);
                }
                if (
                  element.receiverInfo &&
                  typeof element.receiverInfo == "string"
                ) {
                  element.receiverInfo = JSON.parse(element.receiverInfo);
                }
                if (
                  (element.senderInfo.hash_id == this.senderHashId &&
                    element.receiverInfo.hash_id == this.receiverHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
                      )) ||
                  (element.senderInfo.hash_id == this.receiverHashId &&
                    element.receiverInfo.hash_id == this.senderHashId &&
                    element.entity_public_hash_id ==
                      localStorage.getItem(
                        SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
                      ))
                ) {
                  this.previousChatHash = element.hash_id;
                }
              }
            });
            console.log(this.previousChatHash);
          }
          this.loaderservice.showLoader = false;
          this.dialog.open(FollowerChatComponent, {
            width: "500px",
            panelClass: "custom-dialog-container",
            data: {
              title: this.selectedFollowerName,
              ref: this.dialog,
              previousChatHash: this.previousChatHash,
              followerImage: this.selectedFollowerImg,
              folowerProfileHash: this.selectedFollowerProfileHash, //
            },
          });
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_SET_ENROLLED_MEMBER_PHONE_NUMBER
      ) {
        if (this.ift) {
          this.ift = false;
          if (resdata.result) {
            this.toChange = true;
            this._apiservice.getEnrolledMemberDetails(this.memberHash);
          }
        }
      }
    });
  }
  ift: boolean = false;
  entityHash: any;
  eph: any;
  memberHash: any;
  toChange: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    this.loader = true;
    this.loaderservice.showLoader = true;
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.entityHash = data.entityHash;
        this.eph = data.eph;
        this.memberHash = data.memberHash;
      }
    });
    this.toChange = true;
    this._apiservice.getEnrolledMemberDetails(this.memberHash);
  }

  createInvoiceForEnrolled(item: any) {
    let data = {
      entityHash: this.entityHash,
      eph: this.eph,
      // serviceType: this.interestType,
      enrolledData: {
        customer_name: item.name,
        customer_country_code: item.country_code,
        customer_phone: item.phone,
        customer_email: item.email,
      },
      memberData: item,
      discountInfo: this.discountInfo,
    };

    this.dialog.open(CreateInvoiceForFitnessComponent, {
      width: "700px",
      data: {
        title: "New Invoice",
        ref: this.dialog,
        data: data,
      },
    });
  }

  editMember() {
    this.loaderservice.showLoader = true;
    let dialogref = this.dialog.open(MemberViewDetailsComponent, {
      width: "750px",
      disableClose: true,
      data: {
        link: "",
        ref: this.dialog,
        title: "Add member",
        memberHash: this.memberDetailsData.hash_id,
        entityHash: this.entityHash,
        eph: this.eph,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.errorcode == 1) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 2) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.toChange = true;
          this._apiservice.getEnrolledMemberDetails(this.memberHash);
        }
      }
    });
  }
  editMemberPersonalData() {
    this.loaderservice.showLoader = true;
    let dialogref = this.dialog.open(MemberEditPersonalDataComponent, {
      width: "750px",
      disableClose: true,
      data: {
        link: "",
        ref: this.dialog,
        title: "Add member",
        memberHash: this.memberDetailsData.hash_id,
        entityHash: this.entityHash,
        eph: this.eph,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.errorcode == 1) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 2) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.toChange = true;
          this._apiservice.getEnrolledMemberDetails(this.memberHash);
        }
      }
    });
  }
  editMemberServicePackage() {
    this.loaderservice.showLoader = true;
    let dialogref = this.dialog.open(MemberEditOptedServicePackagesComponent, {
      width: "750px",
      disableClose: true,
      data: {
        link: "",
        ref: this.dialog,
        title: "Add member",
        memberHash: this.memberDetailsData.hash_id,
        entityHash: this.entityHash,
        eph: this.eph,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.errorcode == 1) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 2) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.toChange = true;
          this._apiservice.getEnrolledMemberDetails(this.memberHash);
        }
      }
    });
  }
  editMemberOptedTimings() {
    this.loaderservice.showLoader = true;
    let dialogref = this.dialog.open(MemberEditOptedTimingsComponent, {
      width: "750px",
      disableClose: true,
      data: {
        link: "",
        ref: this.dialog,
        title: "Add member",
        memberHash: this.memberDetailsData.hash_id,
        entityHash: this.entityHash,
        eph: this.eph,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        if (res.errorcode == 1) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else if (res.errorcode == 2) {
          this.loaderservice.showLoader = false;
          const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
            width: "500px",
            data: {
              title: "Alert",
              message:
                "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section.",
              okbtn: "Ok",
              cancelbtn: "Cancel",
              type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
            },
            disableClose: true,
          });
        } else {
          this.toChange = true;
          this._apiservice.getEnrolledMemberDetails(this.memberHash);
        }
      }
    });
  }

  openAllInvoices(item: any) {
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    console.log(item);

    this.router.navigate(["all-payments"], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
      },
    });
  }
  openDueInvoices(item: any) {
    sessionStorage.setItem("currentSelectedMember", item.hash_id);
    this.router.navigate(["due-payments"], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
      },
    });
  }

  formatSchedule(schedule: any[]) {
    return schedule.map((item) => {
      const weekday = this.getWeekdayString(item.weekday);
      const startTime = this.formatTime(item.start_time);
      const endTime = this.formatTime(item.end_time);
      return `${weekday}: ${startTime} - ${endTime}`;
    });
  }
  formatTime(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  deleteMember(item: any) {
    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this member?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          memberHash: item.hash_id,
          entityHash: this.entityHash,
        };

        this.loaderservice.showLoader = true;
        this._apiservice.deleteEntityMember(obj);
      }
    });
  }
  updateEnrolledMemberMembershipStatus(item: any, status: any) {
    let msg = "";
    if (status == 1) {
      msg = "revive";
    } else if (status == 2) {
      msg = "cancel";
    }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Alert",
        message:
          "Are you sure you want to " + msg + " the membership of this member?",
        cancelbtn: "No",
        okbtn: "Yes",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        let obj = {
          memberHash: item.hash_id,
          entityHash: this.entityHash,
          membershipStatus: status,
          currentDate: this.formatDate1(new Date()),
        };

        this.loaderservice.showLoader = true;
        this._apiservice.updateEnrolledMemberMembershipStatus(obj);
      }
    });
  }
  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);
    console.log(curdate);

    return curdate;
  }

  openmarkabsent(rowvalue: any) {
    this.dialog.open(MarkAbsentComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Mark absent",
        entityHash: this.entityHash,
        memberHash: rowvalue.hash_id,
      },
    });
  }

  openViewAttendance(rowvalue: any) {
    console.log(this.entityHash);

    this.router.navigate(["view-attendance"], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
      queryParams: {
        entityHash: this.entityHash,
        memberHash: rowvalue.hash_id,
        mn: rowvalue.name,
      },
    });
  }

  onChangePhoneNumber() {
    let dialogref = this.dialog.open(EnrolledMemberPhoneChangeComponent, {
      width: "500px",
      disableClose: true,
      data: {
        link: "",
        title: "Mark absent",
        memberHash: this.memberHash,
      },
    });
    dialogref.afterClosed().subscribe((data) => {
      if (data) {
        this.toChange = true;
        this._apiservice.getEnrolledMemberDetails(this.memberHash);
      }
    });
  }

  selectedFollowerName: any;
  selectedFollowerImg: any;
  selectedFollowerProfileHash: any;
  previousChatHash: any = null;
  senderHashId: any = localStorage.getItem(SM_CONSTANTS.PROFILE_HASH);
  receiverHashId: any;
  isFromThis: boolean = false;
  openMessages(rowvalue: any) {
    this.isFromThis = true;
    this.selectedFollowerName = rowvalue.name;
    this.selectedFollowerImg = rowvalue.image_thumb_url;
    this.selectedFollowerProfileHash = rowvalue.profile_hash;
    this.receiverHashId = rowvalue.profile_hash;
    this.loaderservice.showLoader = true;
    this._apiservice.getMessagesByID();
  }
  openPaymentIntimation(item: any) {
    this.dialog.open(PaymentIntimationComponent, {
      width: "700px",
      data: {
        title: "Payment Intimation",
        ref: this.dialog,
        data: item,
        type: 2,
        entity_hash: this.entityHash,
      },
    });
  }

  opentrack() {
    this.router.navigate(["tracking-item"], {
      queryParamsHandling: "merge",
      relativeTo: this.route,
      queryParams: {
        // hash:
        // mn: this.memberDetailsData.hash_id,
      },
    });
  }

  onResend() {
    const dialogRef = this.dialog.open(AlertForEmailComponent, {
      width: "450px",
      data: {
        title: "Alert!",
        message1:
          "Are you sure want to re-send the invitation to this phone number?",
        message2: `${this.memberDetailsData.country_code} ${this.memberDetailsData.phone}`,
        okbtn: "Yes",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          memberHash: this.memberHash,
          countryCode: this.memberDetailsData.country_code,
          phone: this.memberDetailsData.phone,
        };

        console.log(data);
        this.loaderservice.showLoader = true;
        this.ift = true;
        this._apiservice.setEnrolledMemberPhoneNumber(data);
      }
    });
  }

  getInvoiceAccess(serviceType: any): boolean {
    if (this.isOwner) return true;
    else {
      const ssa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_INVOICE_ACCESS,
      );
      const hsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_INVOICE_ACCESS,
      );
      const vsa = sessionStorage.getItem(
        SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_INVOICE_ACCESS,
      );

      const bsss = sessionStorage.getItem("shop_service_status");
      const bhss = sessionStorage.getItem("home_service_status");
      const bvss = sessionStorage.getItem("virtual_service_status");

      if (
        (ssa == "1" && bsss != "2" && serviceType == "1") ||
        (hsa == "1" && bhss != "2" && serviceType == "0") ||
        (vsa == "1" && bvss != "2" && serviceType == "2")
      ) {
        return true;
      }
    }

    return false;
  }

  openwallemoney(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["customer-wallet-money"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        memail: item.email,
      },
    });
  }
  openrewardpoint(item: any) {
    sessionStorage.setItem("cusphoneforbill", item.country_code);
    this.router.navigate(["reward-points"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: {
        phone: item.phone,
        code: item.country_code,
        mn: item.name,
        memail: item.email,
      },
    });
  }

  openGoogleMaps(rowvalue: any): void {
    // Construct the Google Maps URL with the provided coordinates
    const mapUrl = `https://www.google.com/maps?q=${rowvalue.lat},${rowvalue.lng}`;

    // Sanitize the URL to make it safe for opening in a new tab
    // const sanitizedUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(mapUrl);
    // console.log(sanitizedUrl.toString());

    // Open a new tab with the Google Maps URL
    window.open(mapUrl, "_blank");
  }
  openLink(rowvalue: any): void {
    if (!rowvalue) return;

    let url = String(rowvalue).trim();

    // Check if the URL starts with http:// or https://
    // If not, prepend https:// to make it absolute
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    window.open(url, "_blank");
  }

  editSessionInfo() {
    let dref = this.dialog.open(EditMemberMeetingInfoComponent, {
      width: "500px",
      data: {
        sessionData: {
          online_session_app: this.memberDetailsData.online_session_app,
          online_session_link: this.memberDetailsData.online_session_link,
          online_session_notes: this.memberDetailsData.online_session_notes,
        },
        memberHash: this.memberHash,
      },
    });

    dref.afterClosed().subscribe((data) => {
      if (data) {
         this.toChange = true;
        this._apiservice.getEnrolledMemberDetails(this.memberHash);
      }
    });
  }
  editAddress() {
    let dref = this.dialog.open(EditMemberAddressComponent, {
      width: "500px",
      data: {
        addressInfo: this.memberDetailsData?.member_address,
        memberHash: this.memberHash,
      },
    });

    dref.afterClosed().subscribe((data) => {
      if (data) {
         this.toChange = true;
        this._apiservice.getEnrolledMemberDetails(this.memberHash);
      }
    });
  }
}
